// extracted by mini-css-extract-plugin
module.exports =  {"hideResults":"hideResults___pMbLI"};